/**
 * @module common/components/form/modal_form_step
 */
import React, { PropTypes } from 'react';
import classNames from 'classnames';

/**
 * Component that renders a modal form step (ie file upload form)
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
const ModalFormStep = ({ title, sidebar, content, buttons }) => {
  const contentClass = classNames('column modal-form-content', {
    'small-16': !sidebar,
    'small-10': sidebar,
  });

  return (
    <div className="row modal-form-step">
      <div className="medium-16 column modal-form-header">
        <h2>{ title }</h2>
      </div>
      { sidebar &&
        <div className="medium-6 column modal-form-sidebar">
          { sidebar }
        </div>
      }
      <div className={contentClass}>
        { content }
      </div>
      <div className="medium-16 column modal-actions">
        { buttons}
      </div>
    </div>
  );
};

/**
 * PropTypes.
 *
 * @property {string} title - title of this form step
 * @property {node} sidebar - content to render in the step sidebar
 * @property {node} content - content to render in the step main element
 * @property {node} buttons - step buttons
 */
ModalFormStep.propTypes = {
  title: PropTypes.string,
  sidebar: PropTypes.node,
  content: PropTypes.node,
  buttons: PropTypes.node,
};

export default ModalFormStep;



// WEBPACK FOOTER //
// ./common/components/form/modal_form_step.jsx